import { Project } from '../interfaces/project';
import { IMAGE_BUCKET_BASE } from './imagebucket-assets';

/** Shown when a project has no cover or gallery images (local asset). */
export const PROJECT_IMAGE_PLACEHOLDER = `${IMAGE_BUCKET_BASE}/placeholder.png`;

/** Owner avatar on project cards and project detail header. */
export const PROFILE_AVATAR_FALLBACK = `${IMAGE_BUCKET_BASE}/profile.png`;

/**
 * Ordered URLs for display: cover (`imageUrl`) first, then `imageUrls` without duplicates.
 * Listing uses `[0]`; project detail uses the full list in the carousel.
 * If there are no URLs, returns a single placeholder image.
 */
export function getProjectImageUrls(project: Project): string[] {
  const cover = project.imageUrl?.trim();
  const extras = (project.imageUrls ?? [])
    .map((u) => u?.trim())
    .filter((u): u is string => Boolean(u));
  let out: string[];
  if (cover) {
    out = [cover];
    const seen = new Set(out);
    for (const u of extras) {
      if (!seen.has(u)) {
        out.push(u);
        seen.add(u);
      }
    }
  } else {
    out = extras;
  }
  if (out.length === 0) {
    return [PROJECT_IMAGE_PLACEHOLDER];
  }
  return out;
}
